<template>
  <div class="callme_total_wrap hidden-xs-only">
    <div class="callme_top_wrap"></div>
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="items_wrap">
          <div class="item_tit">産品</div>
          <div class="item_options">
            <span>産業大腦</span>
            <span>雲招商</span>
            <span>企業創新服務</span>
            <span>企業咨詢</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">內容中心</div>
          <div class="item_options">
            <span>行業報告</span>
            <span>精選文章</span>
            <span>媒體報道</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">聯繫我們</div>
          <div class="item_options">
            <el-menu
              :default-active="activeIndex"
              class="el_menu_demo"
              mode="horizontal"
              background-color="#21282D"
              text-color="#8F9095"
              active-text-color="#8F9095"
              @select="handleSelect"
            >
              <el-menu-item index="1" class="el_menu_item">香港</el-menu-item>
              <!-- <el-menu-item index="2" class="el_menu_item">寶雞</el-menu-item>
              <el-menu-item index="3" class="el_menu_item">咸陽</el-menu-item> -->
              <!-- <el-menu-item index="4" class="el_menu_item">渭南</el-menu-item> -->
            </el-menu>
            <div class="massage_show">
              <!-- <p>{{ cityInfomation[showCity].phone }}</p> -->
              <p>
                <a href="mailto:GrouplimteOmniscient@outlook.com">{{
                  cityInfomation[showCity].eamil
                }}</a>
              </p>
              <p>{{ cityInfomation[showCity].address }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="items_wrap hidden-md-and-down" style="margin-left: 120px">
          <div class="item_tit">關注我們</div>
          <div class="item_options">
            <img src="@/assets/img/guanzhu.png" alt="" />
            <span style="text-align: center; margin-top: 15px"
              >萬知産業大腦...</span
            >
          </div>
        </div> -->
        <!-- <div class="items_wrap hidden-md-and-down">
          <div class="item_tit">關注我們</div>
          <div class="item_options">
            <img src="@/assets/img/guanzhu.png" alt="" />
            <span style="text-align: center; margin-top: 15px"
              >萬知産業大腦...</span
            >
          </div>
        </div> -->
      </div>
      <!-- <div class="navigate_wrap">
        <span>友情链接:</span>
        <a href="http://www.gov.cn/">中华人民共和国中央人民政府</a>
        <a href="http://www.miit.gov.cn/">中华人民共和国工業和信息化部</a>
        <a href="https://www.fmprc.gov.cn/chn/gxh/tyb/">中华人民共和国外交部</a>
        <a href="http://www.tobacco.gov.cn/">国家烟草专卖局</a>
        <a href="http://www.cinn.cn/">中国工業新闻网</a>
        <a href="http://www.ccidnet.com/">赛迪网</a>
        <a href="http://www.cena.com.cn/">中国电子信息产業</a>
        <a href="http://www.ccidmedia.com/">赛迪传媒</a>
        <a href="http://www.cio360.net/">中国信息主管网</a>
        <a href="http://www.ccidcom.com/">通信产業网</a>
        <a href="#">赛迪呼叫</a>
        <a href="http://www.mtx.cn/">赛迪顾问</a>
        <a href="http://www.cciddata.com/">赛迪数据在线</a>
        <a href="http://www.cstc.org.cn/">中国软件评测中心</a>
        <a href="http://www.ccidit.com/">赛迪时代</a>
        <a href="http://www.chinaeinet.com/">中国工業和信息化</a>
        <a href="http://www.saism.com.cn/">软件和集成电胳</a>
        <a href="http://www.ccidreport.com/">中市场情报中心</a>
        <a href="http://www.mtx.cn">满天星·产業通</a>
        <a href="http://www.ccidti.com/">赛迪科创</a>
        <a href="https://wjt.ccidit.com/Sy/">赛迪问卷通</a>
        <a href="https://www.yaoxuanzhi.com/">药选址</a>
        <a href="http://www.cpupps.cn/">药学进展</a>
        <a href="http://www.biotechchina.org/">中国生物工程学会</a>
        <a href="http://www.zchsp.com/">浙江省健康服務業促进会</a>
        <a href="https://www.biodiscover.com/">生物探索</a>
        <a href="https://med.sina.com/">新浪医药</a>
        <p>
          Copyright ©2020 万知创造 . All Rights Reserved . 浙ICP备15031491号-1
          浙公网安备 33010802005636号
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      cityInfomation: [
        {
          phone: "0000-000-0000",
          eamil: "GrouplimteOmniscient@outlook.com",
          address: "香港九龍尖沙咀廣東道30號新港中心第1座602A"
        }
        // {
        //   phone: '028-86713133',
        //   eamil: 'Contact@hsmap.com',
        //   address: '陝西省寶雞市高新開發區高新大道50號財富大厦B座1407室',
        // },
        // {
        //   phone: '0571-86885326',
        //   eamil: 'Contact@hsmap.com',
        //   address: '陝西省咸陽市渭城區人民中路銀都國際A座1309',
        // },
        // {
        //   phone: '15051586330',
        //   eamil: 'Contact@hsmap.com',
        //   address: '重庆市九龙坡区华岩镇华锦路26号',
        // },
      ],
      showCity: 0
    };
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1;
    },
    handleToRouter(url) {
      this.$router.replace(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  // margin-top: 80px;
  .callme_top_wrap {
    width: 100%;
    height: 18.75rem;
    background: url("../../assets/img/banner/bottombg.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 4.3rem;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 3.75rem;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 6.25rem;
        .item_tit {
          font-size: 1.4rem;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 7.5rem;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 1rem !important;
            margin-top: 2.1rem;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 0.625rem;
            width: 18.75rem;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 0.93rem;
            width: 18.75rem;
            height: 5rem;
            p {
              margin-top: 1.875rem;
            }
          }
          img {
            width: 100%;
            margin-top: 1.25rem;
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 2.5rem;
      padding-bottom: 0.9375rem;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 1rem;
        margin-right: 2rem;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 1.875rem;
        font-size: 1.125rem;
        margin-right: 0;
      }
      p {
        font-size: 1rem;
        color: #4e5557;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/callme/index.vue